import { render, staticRenderFns } from "./AddMaterialsModal.vue?vue&type=template&id=478716e5&scoped=true"
import script from "./AddMaterialsModal.vue?vue&type=script&lang=js"
export * from "./AddMaterialsModal.vue?vue&type=script&lang=js"
import style0 from "./AddMaterialsModal.vue?vue&type=style&index=0&id=478716e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478716e5",
  null
  
)

export default component.exports